import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PostcodesComponent } from '../../components/manage-postcodes/manage-postcodes.component';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { PostcodeMapsModule } from './postcode-maps.module';

const routes: Routes = [
  { path: '', component: PostcodesComponent, data: { title: 'Manage Postcodes' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PostCodesRoutingModule {}

@NgModule({
  imports: [
    PostCodesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    PostcodeMapsModule,
  ],
  declarations: [PostcodesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PostCodesModule {}
